module.exports = __webpack_public_path__ + "3dc948192d340bd4079f5404191ec9a6.png";